import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class TimeSheetTrafficPlanTemplate extends ApiBase {
    constructor (store) {
        const path = ACTIVE_BASE_REST + '/timeSheet/trafficPlan/template'
        super(store, path)
    }
}